<template>
  <button type="button" class="theme-toggle" :title="title" @click="toggle">
    <span>{{ isDark ? '🌙' : '☀️' }}</span>
    <span>{{ isDark ? '夜间' : '日间' }}</span>
  </button>
</template>

<script>
// 日间 / 夜间切换。默认日间；用户手动切过才记住（与桌面客户端同一套约定）。
// 主题实现只做一件事：给 <html> 加/去 data-theme="dark"，
// 具体配色全部由 src/assets/theme.css 的变量承担。
const STORAGE_KEY = 'pix-web-theme'

export default {
  name: 'ThemeToggle',
  data() {
    return { isDark: false }
  },
  computed: {
    title() {
      return this.isDark ? '当前：夜间模式，点击切换到日间' : '当前：日间模式，点击切换到夜间'
    }
  },
  created() {
    this.isDark = document.documentElement.getAttribute('data-theme') === 'dark'
  },
  methods: {
    toggle() {
      this.isDark = !this.isDark
      if (this.isDark) document.documentElement.setAttribute('data-theme', 'dark')
      else document.documentElement.removeAttribute('data-theme')
      try {
        // 只记用户主动选过的值，供下次首帧预热使用
        localStorage.setItem(STORAGE_KEY, this.isDark ? 'dark' : 'light')
      } catch (e) {}
      // 通知页面里需要跟着主题变的部分（例如后台侧栏是用 prop 传色的 el-menu，
      // 不是纯 CSS 变量能覆盖的），它们监听这个事件自行更新
      document.dispatchEvent(new CustomEvent('pix-theme-change', { detail: { dark: this.isDark } }))
    }
  }
}
</script>

<style scoped>
/*
 * `white-space: nowrap` 与 `flex-shrink: 0` 不是装饰，是防压缩。
 * 去掉它们之后，这个按钮作为 flex 子项会被父容器挤扁：
 * 文案折成两行、高度塌下去，白天/夜间两字上下叠在一起 —— 就是"UI 坏了"。
 */
.theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid var(--w-border);
  background: var(--w-surface);
  color: var(--w-text-muted);
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background .18s ease, color .18s ease, border-color .18s ease;
}
</style>
